export default "__VITE_ASSET__CQ4u3BlW__"